import { NgModule } from "@angular/core";
import { StakingRewardIntervalPipe } from "@modules/staking/domain/pipes/stake-reward-interval.pipes";
import { CoreModule } from "@modules/core/core.module";
import { CommonModule } from "@angular/common";
@NgModule({
	imports: [CoreModule, CommonModule],
	declarations: [StakingRewardIntervalPipe],
	exports: [StakingRewardIntervalPipe, CoreModule, CommonModule]
})
export class StakingUtlityModule {}
